



















































import { Component, Vue, Prop, Emit, Model } from "vue-property-decorator";
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import EntityListPage from '@/views/shared/EntityListPage.vue';


@Component({
  components: {
    DxTextBox,
    DxTextBoxButton,
    EntityListPage
  }
})
export default class ListPicker extends Vue {
  @Prop({
    required: true
  })
  public entityName!: string;

  @Prop({
    required: true
  })
  public textValueKey!: string;

  @Prop({
    required: true
  })
  public value!: any;

  @Prop() public nullable!: boolean;

  public get isNullableField(): boolean {
    return this.nullable === true;
  }

  public get isNullableButtonVisible(): boolean {
    return (this.value !== null && this.value !== void 0);
  }

  public resetButton = {
    icon: 'fa fa-window-close',
    type: 'danger',

    onClick: () => {
      this.value = null;
      this.emitModelChange(this.value);
    }
  }

  public searchButton = {
      icon: 'fa fa-search',
      type: 'default',
      onClick: () => {
        (this.$refs['modal-pickup'] as any).show();
      }
  }

  public onItemSelected($event: any) {
    console.info('-> dovrebbe aver invocato onItemSelected...');
    console.log('$event ricevuto:', $event);
    this.value = { ...$event };
    this.emitModelChange($event);
    (this.$refs['modal-pickup'] as any).hide();
    console.info('-> this.value is now', this.value);
  }

  @Emit('input')
  public emitModelChange(modelValue: any) {
    console.info('-> emitted modelChange to', modelValue);
  }

  public get valueText(): string {
      return (this.value && this.value[this.textValueKey]) || '';
  }

  constructor() {
    super();
  }

  async mounted() {
    // console.info('this.value is', this.value)
  }
}
